module.exports = __webpack_public_path__ + "static/img/success_pic.6e3fdf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/service/success_pic.png
// module id = 8FnW
// module chunks = 86